export default __webpack_public_path__ + "static/media/zawodnik11.299f3336.png";